module.exports = __webpack_public_path__ + "static/media/colombiaflag.3d91b85f.png";